<template>
  <footer class="global-footer">
    <div class="w-1200 mx-auto fz-12 copyright">
      <span style="margin-right: 23px;">{{ config.copyright }} </span>
      <span class="beian">
        <img src="https://co-image.qichacha.com/upload/chacha/img/20191206/1575615736779577.png" alt="">
         &nbsp;
         {{ config.beian }}
        </span>
      <a
        v-if="config.beian === '沪ICP备13026404号-9' && config.telecom_license"
        class="telecom-license"
        :href="config.telecom_license_url"
        target="_blank"
        rel="noopener noreferrer"
      >增值电信业务经营许可证 {{ config.telecom_license }}</a>
    </div>
  </footer>

</template>

<script>
export default {
  mounted() {
    this.layoutParent = this.$el.parentElement
    if (this.layoutParent) {
      this.layoutParent.classList.add('has-page-footer')
    }
  },
  beforeDestroy() {
    if (this.layoutParent) {
      this.layoutParent.classList.remove('has-page-footer')
    }
  }
};

</script>

<style lang="scss">
.has-page-footer {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.has-page-footer > .main-bg {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}

.has-page-footer > .main-bg > .ownper_box,
.has-page-footer > .main-bg > .main {
  flex: 1 0 auto;
}

.has-page-footer > .global-footer {
  flex-shrink: 0;
}

.has-page-footer:not(:has(> .main-bg)) > .global-footer {
  margin-top: auto;
}
</style>

<style scoped lang="scss">

.global-footer {
  width: 100%;
  height: 66px;
  background-color: #232426;
  color: #fff;

  .copyright {
    height: 100%;
    color: rgba(255, 255, 255, .6);
    display: flex;
    justify-content: center;
    align-items: center;

    .beian {
      display: flex;
      align-items: center;
    }

    .telecom-license {
      margin-left: 16px;
      color: inherit;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/global/Footer.vue